import { HostFamily } from '../../../lib/types/models/host-family/host-family'
import {
  HostFamilyInput,
  HostFamilyRequest
} from '../../../lib/types/models/host-family/host-family-input'

export const mapHostFamilyToInput = (hostFamily: HostFamily): HostFamilyInput => ({
  accomodationType: hostFamily.accomodationType,
  address1: hostFamily.address1,
  children: hostFamily.children.map(({ id: _id, ...child }) => ({ ...child })),
  city: hostFamily.city,
  country: hostFamily.country,
  deactivated: hostFamily.deactivated,
  deactivationReason: hostFamily.deactivationReason,
  createdAt: hostFamily.createdAt,
  familyName: hostFamily.familyName,
  hasPets: hostFamily.hasPets,
  hobbies: hostFamily.hobbies,
  withGarden: hostFamily.withGarden,
  isSharedRoom: hostFamily.isSharedRoom,
  maritalStatus: hostFamily.maritalStatus,
  numberOfBedrooms: hostFamily.numberOfBedrooms,
  parent1DateOfBirth: hostFamily.parent1DateOfBirth,
  parent1Email: hostFamily.parent1Email,
  parent1FirstName: hostFamily.parent1FirstName,
  parent1LastName: hostFamily.parent1LastName,
  parent1Nationality: hostFamily.parent1Nationality,
  parent1Position: hostFamily.parent1Position,
  parent1PositionStatus: hostFamily.parent1PositionStatus,
  parent2PositionStatus: hostFamily.parent2PositionStatus,
  relatives: hostFamily.relatives.map(({ id: _id, ...relative }) => ({ ...relative })),
  updatedAt: hostFamily.updatedAt,
  timeToSchool: hostFamily.timeToSchool,
  transportToSchool: hostFamily.transportToSchool,
  zipCode: hostFamily.zipCode,
  address2: hostFamily.address2,
  dateOfVisit: hostFamily.dateOfVisit,
  otherInformation: hostFamily.otherInformation,
  parent1PhoneNumber: hostFamily.parent1PhoneNumber,
  parent2DateOfBirth: hostFamily.parent2DateOfBirth,
  parent2Email: hostFamily.parent2Email,
  parent2FirstName: hostFamily.parent2FirstName,
  parent2LastName: hostFamily.parent2LastName,
  parent2Nationality: hostFamily.parent2Nationality,
  parent2PhoneNumber: hostFamily.parent2PhoneNumber,
  parent2Position: hostFamily.parent2Position,
  petDescription: hostFamily.petDescription,
  pickupPoint: hostFamily.pickupPoint,
  studentAccomodationComment: hostFamily.studentAccomodationComment,
  localRepresentativeFirstName: hostFamily.localRepresentativeFirstName,
  localRepresentativeLastName: hostFamily.localRepresentativeLastName,
  localRepresentativePhone: hostFamily.localRepresentativePhone,
  localRepresentativeEmail: hostFamily.localRepresentativeEmail,
  trainStation: hostFamily.trainStation,
  visitedBy: hostFamily.visitedBy,
  picturesAndVideos: hostFamily.picturesAndVideos
})

export const mapHostFamilyInputToRequest = ({
  createdAt: _createdAt,
  updatedAt: _updatedAt,
  deactivated: _deactivated,
  deactivationReason: _deactivationReason,
  ...hostFamily
}: HostFamilyInput): HostFamilyRequest => hostFamily
